<form [formGroup]="form">
  <mat-list>
    <mat-accordion multi="true">
      @for (group of settings; track group) {
        <div [formGroup]="form" class="form-row">
          <ldw-vmp-form-group [captionWidth]="captionWidth" [form]="form"
          [vmpList]="group"></ldw-vmp-form-group>
        </div>
      }
    </mat-accordion>
  </mat-list>
</form>




